// Change Inventory Status on variant change
document.addEventListener('product:variant-change', (event) => {
  const inventoryStatusEl = document.querySelector('.ProductForm__InventoryStatus');
  if (!inventoryStatusEl) return;
  
  const { variant } = event.detail;
  const variantInventory = variantInventories.find(key => key.id === variant.id);
  
  inventoryStatusEl.innerHTML = `${variantInventory.message}`; 
});